import { render } from "./Button.md?vue&type=template&id=64f326f4"
const script = {}
script.render = render

export default script